// 新增/编辑产品批号
<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">{{ title }}</div>
      </div>
      <div class="import-title">
        <!-- <div class="cost-title-list">
          <span class="cost-title-list-line"></span>
          <span class="cost-title-list-txt">基础信息</span>
        </div> -->
        <span class="cost-title-list-txt">基础信息</span>
      </div>
      <div class="customer-information">
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>公司名称</div>
            <el-select
              size="small"
              :disabled="isDisabled || ($route.query.guid ? true : false) || ($route.query.isMain ? true : false)"
              v-model="ruleForm.tenantGuid"
              placeholder="请选择"
              filterable
              @change="changeTenant"
              class="w300"
            >
              <el-option
                v-for="item in tenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>选择产品</div>
            <div class="w300" style="text-align: left">
              <el-input
                :disabled="isDisabled"
                size="small"
                @focus="openProductList()"
                class="w300"
                readonly
                v-model="ruleForm.goodsName"
                placeholder="请选择"
              >
                <i class="el-icon-arrow-down el-input__icon" slot="suffix" @click="openProductList()"> </i>
              </el-input>
            </div>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <div class="title">产品规格</div>
            <div class="txt">{{ ruleForm.goodsSpec }}</div>
          </div>
          <div class="col-itms second">
            <div class="title">生产厂家</div>
            <div class="txt">{{ ruleForm.producer }}</div>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>产品批号</div>
            <el-input
              size="small"
              :disabled="isDisabled"
              class="w300"
              maxlength="15"
              placeholder="请输入"
              v-model="ruleForm.lotNo"
              @input="handleInput"
              @focus="handleFocus"
              @blur="handleBlur"
            ></el-input>
            
          </div>
          <div class="col-itms second flex-start">
            <div class="title" style="line-height: 32px;">生产日期</div>
            <el-date-picker
              v-model="ruleForm.productDate"
              align="right"
              type="date"
              class="w300"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="getValidOptions"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
        <div class="cols">
          <div class="col-itms">
            <div class="title">有效期</div>
            <el-date-picker
              v-model="ruleForm.expiryDate"
              align="right"
              type="date"
              class="w300"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="validPickerOptions">
            </el-date-picker>
          </div>
          <div class="col-itms second">
            <div class="title">启用状态</div>
            <div class="w300" style="text-align: left">
              <el-radio
                :disabled="isDisabled"
                style="width: 70px"
                v-model="ruleForm.bizState"
                label="Y"
                >启用</el-radio
              >
              <el-radio
                :disabled="isDisabled"
                style="width: 70px"
                v-model="ruleForm.bizState"
                label="S"
                >停用</el-radio
              >
            </div>
          </div>
          
        </div>
        
       
      </div>

      <div class="operte-btns">
        <div class="btn cancel" @click="$router.go(-1)">取消</div>

        <el-button size="medium" type="info" v-if="!isDisabled" @click="submitForm()"> 确定 </el-button>
      </div>
    </div>

    <!-- 产品列表 start -->
    <div class="product-list">
      <el-dialog width="910px" top="7vh" :title="'选择产品'" :visible.sync="showProductDialog" left>
        <div slot="title" class="dialog-title">
          {{ '选择产品' }}
        </div>
        <div class="product-content">
          <div class="product-search">
            <el-row :gutter="24">
              <el-col :span="10">
                <div class="search-area-div">产品名称</div>
                <el-input
                  v-model="page.goodsName"
                  size="mini"
                  class="ipt-sty"
                  placeholder="请输入名称"
                  :clearable="true"
                ></el-input>
              </el-col>
              <el-col :span="10" class="search-btn-box">
                <el-button size="mini" type="info" @click="searchProduct(1)">搜索</el-button>
                <el-button size="mini" @click="empty">清空</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="back-color-fff product-list-table">
            <!-- 列表 -->
            <el-table
              ref="table"
              :data="productTableData"
              stripe
              border
              style="width: 100%"
              max-height="400"
              @row-click="rowClickHandle"
              highlight-current-row
            >
              <el-table-column align="center" width="80" label="选择">
                <template slot-scope="scope">
                  <el-radio class="radio" v-model="selectCode" :label="scope.row.guid">
                    <span></span>
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="goodsName"
                label="产品"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">
                  <!-- 产品图片 -->
                  <div style="display: flex; align-items: center">
                    <img
                      v-if="scope.row.pictContent && scope.row.productImgUrl.path"
                      width="56"
                      height="56"
                      :src="scope.row.productImgUrl.path"
                      alt=""
                    />
                    <div>{{ scope.row.goodsName || '-' }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="goodsSpec"
                label="规格"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
              </el-table-column>
              <el-table-column
                prop="producer"
                label="生产企业"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="210"
              >
                <template slot-scope="scope">{{ scope.row.producer || '-' }}</template>
              </el-table-column>
              <el-table-column prop="price" label="单价" show-overflow-tooltip header-align="center" align="right">
                <template slot-scope="scope">{{ scope.row.price === 0? 0 : (scope.row.price || '-') }}</template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="page.pageIndex"
            :page-size="page.pageSize"
            :total="page.totalRows"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
        <div class="operte-btns" style="padding: 0;">
          <div class="btn cancel" @click="showProductDialog = false">取消</div>
          <div class="btn submit" @click="submitPro()">确定</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import { forIn } from 'lodash';
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      validPickerOptions:{},
      showMore: false,
      tableHeight: window.innerHeight - 280,
      productInformationList: [],
      tenantList: [],
      ruleForm: {
        guid: '',
        tenantGuid: '',//公司名称
        goodsGuid: '',//产品guid
        goodsName: '',
        goodsSpec:'',//产品规格
        producer:'',//生产厂家
        lotNo:'',//产品批号
        productDate:'',//生产日期
        expiryDate:'',//有效期
        bizState: 'Y',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        goodsCode: '',
        goodsName: '',
        isCompetitor:'N',
      },
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        goodsCode: [
          { required: true, message: '请输入商品编码', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        // price: [
        //   { required: true, message: '请输入单价', trigger: 'blur' },
        // ],
        goodsSpec: [
          { required: true, message: '请输入商品规格', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        unitStyle: [
          { required: true, message: '请输入商品单位', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        producer: [
          { required: true, message: '请输入商品生产厂商', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        bigUnitQty: [
          { required: true, message: '请输入商品生产厂商', trigger: 'blur' },
          { min: 1, max: 10000, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        // bizUnitGuid: [{ required: true, message: '请选择核算单元', trigger: 'blur' }],
        goodsClassGuids: [{ required: true, message: '请选择产品大类', trigger: 'blur' }], // 商品大类
      },
      textTitle: '',
      dialogFormVisible: false,
      right: '',
      loading: false,
      unitsData: [],

      bizUnitNames: [],
      pictContentList: [],
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.token,
      },
      //导入
      active: 0,
      id: '',
      dialogFormVisibleII: false,
      fullscreenLoading: false,
      file: '',
      msg: '',
      showBtn: false,
      progressGuid: '',
      percentage: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      showProductDialog: false,
      dialogType: '',
      dialogFormVisibleIITitle: '批量导入产品',
      goodsTreeData: [],
      cascaderProps: {
        //角色级联
        value: 'guid',
        label: 'text',
        children: 'childDictList',
        multiple: true,
        emitPath: false,
      },
      invoiceAttach: [],
      selectProduct: {},
      productTableData: [],
      selectCode: '',
    };
  },
  computed: {
    isDisabled() {
      // !查看模式
      return this.$route.query.operationMode === 'look';
    },
    isCompetitors() {
      // 是否竞品
      return this.ruleForm.isCompetitor === 'Y';
    },
    labelName() {
      return this.isCompetitors ? '竞品' : '产品';
    },
    title() {
      return this.$route.query.guid
        ? '编辑产品批号'
        : '新增产品批号';
    },
    
  },
  created() {
    // 获取商品大类数据
    this.getPositionList();
    this.getTenantOperationRelList();
    // 格式化编辑资料
    if (this.$route.query.guid) this.getProductInfo();
    // if (this.$route.query.tenantGuid) {
    //   // 从药企进入的新增
    //   this.ruleForm.tenantGuid = this.$route.query.tenantGuid;
    //   this.changeTenant(this.$route.query.tenantGuid);
    // }
    if (this.$route.query.isMain) {
      let isMain = this.$route.query.isMain;
      this.ruleForm.isCompetitor = isMain == 1 ? 'N' : 'Y';

      this.ruleForm.isMain = 'Y';
    }
  },
  methods: {
    handleInput(event) {
      console.log('event',event);
      const filteredValue = event.replace(/[^0-9a-zA-Z-]/g, '');
      if (event!== filteredValue) {
        this.ruleForm.lotNo = filteredValue;
      }
    },
    handleFocus(){
      if (!this.ruleForm.goodsName) {
        this.$message.error('请先选择产品');
        return;
      }
    },
    handleBlur(){
      if(!this.ruleForm.lotNo)return
      let param={
        guid:this.$route.query.guid||'',
        tenantGuid:this.ruleForm.tenantGuid,
        goodsGuid:this.ruleForm.goodsGuid,
        lotNo:this.ruleForm.lotNo
      }
      
      let url = `/${serverConfig.msProductService}/goods-lot/check-duplicate`;
      // url: `/${serverConfig.msCustomerService}/goods-lot/check-duplicate`,
      //     param: {
      //       guid:this.$route.query.guid || '',
      //       tenantGuid: this.ruleForm.tenantGuid,
      //       franchiseeName: this.ruleForm.franchiseeName,
      //     },
      //     tipMsg:'该客户已存在，请勿重复建档'
      this.api.postJson(url, param).then(res=>{
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
          let data = res.data.data;
          if(data){
            this.$message.error(data)
          }
        } 
      })
    },
   
    getValidOptions(val){
      console.log('val',val,this.ruleForm.productDate);
      
      this.validPickerOptions = {
        disabledDate(time) {
          return time.getTime() < new Date(val).getTime();
        },
      }

    },
    //获取公司下拉
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
            if (self.$route.query.tenantGuid) {
              self.ruleForm.tenantGuid = self.$route.query.tenantGuid;
              self.$forceUpdate();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getProductInfo() {
      let guid = this.$route.query.guid;
      let query={
        guid: guid,
      }
      this.api.postJson(`/${serverConfig.msProductService}/goods-lot/list`,query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let productInfo = res.data.data.records[0] || {};
          for (const key in this.ruleForm) {
            if (Object.hasOwnProperty.call(this.ruleForm, key)) {
              this.ruleForm[key] = productInfo[key];
            }
          }
          console.log('ruleForm', this.ruleForm);
          
         
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getCompetitorInfo(guid) {
      this.api.get(`/${serverConfig.msProductService}/goods/detail/${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.selectProduct = res.data.data || {};
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    
    
  
    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: this.ruleForm.tenantGuid,
        goodsCode: '',
        goodsName: '',
        isCompetitor:'N',
      };
      this.searchProduct(1);
    },
    

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.searchProduct(1);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.searchProduct();
    },
    checkForm() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('选择公司');
        return false;
      }

      if (!this.ruleForm.goodsName) {
        this.$message.error('请输入产品名称');
        return false;
      }
      console.log('lotNo',this.ruleForm.lotNo,this.ruleForm);
      
      if (!this.ruleForm.lotNo) {
        this.$message.error('请输入产品批号');
        return false;
      }

      // if (!this.ruleForm.goodsCode) {
      //   this.$message.error('请输入产品编码');
      //   return false;
      // }
      console.log('000',this.ruleForm.expiryDate,this.ruleForm.productDate);
      
      console.log('new Dat',new Date(this.ruleForm.expiryDate).getTime()<new Date(this.ruleForm.productDate).getTime());
      
      if (new Date(this.ruleForm.expiryDate).getTime()<new Date(this.ruleForm.productDate).getTime()) {
        this.$message.error('有效期不可以早于生产日期');
        return false;
      }

      
      return true;
    },
    submitForm() {
      if (!this.checkForm()) { // 表单校验
        return;
      }
      
      let self = this;
      let url = `/${serverConfig.msProductService}/goods-lot/add`;
      let method = this.$route.query.guid ? 'put' : 'postJson';
     
      self.fullscreenLoading = true;
      
      let promise = {
        tenantGuid: self.ruleForm.tenantGuid,
        // goodsCode: self.ruleForm.goodsCode,
        // goodsName: self.ruleForm.goodsName,
        // goodsSpec: self.ruleForm.goodsSpec,
        goodsGuid: self.ruleForm.goodsGuid,
        lotNo: self.ruleForm.lotNo,
        productDate: self.ruleForm.productDate,
        expiryDate: self.ruleForm.expiryDate,
        bizState: self.ruleForm.bizState,
        
      };
      if (this.$route.query.guid) {
        promise.guid = this.$route.query.guid;
        url = `/${serverConfig.msProductService}/goods-lot/update`;
      }
      
      self.api[method](url, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.fullscreenLoading = false;
          self.$message.success(this.$route.query.guid ? '编辑产品批号成功' : '添加产品批号成功');
          this.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
    
    /** 产品图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.pictContentList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.pictContentList.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '产品图片',
              url: res.data.data,
            };
            self.pictContentList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },

    /**
     * 获取商品大类字典
     */
    getPositionList() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=商品大类字典`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsTreeData = res.data.data || [];
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
    },
    onPreview(file) {
      let fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    // 打开选择产品列表
    openProductList() {
      let { ruleForm } = this;
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
      this.page= {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: this.ruleForm.tenantGuid,
        goodsCode: '',
        goodsName: '',
        isCompetitor:'N',
      
      }
      this.showProductDialog = true;
      this.searchProduct(1);
    },
    searchProduct(flg) {
      if(flg){
        this.page.pageIndex=1
      }
      this.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.productTableData = res.data.data.records.filter((item) => item.guid !== this.$route.query.guid);
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;
          this.productTableData.forEach((item) => {
            if (item.pictContent && Array.isArray(JSON.parse(item.pictContent))) {
              item.productImgUrl = JSON.parse(item.pictContent)[0] || {};
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    rowClickHandle(row) {
      this.selectCode = row.guid;
      this.selectProduct = this.productTableData.find((item) => item.guid === row.guid);
      console.log('selectProduct',this.selectProduct);
      
    },
    submitPro(){
      this.showProductDialog = false
      this.ruleForm.goodsGuid=this.selectProduct.guid
      this.ruleForm.goodsName=this.selectProduct.goodsName
      this.ruleForm.goodsSpec=this.selectProduct.goodsSpec
      this.ruleForm.producer=this.selectProduct.producer
    },
    changeTenant(tenantGuid) {
      if (tenantGuid) {
        
        // this.getUnitsData(tenantGuid);
      }
    },
    focusBizUnitGuid() {
      if (!this.ruleForm.tenantGuid) {
        this.$message.error('请先选择公司');
        return;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    /**
     * 产品大类的选择(
     * 如果选择了药品分类中三项的其中一项，
     * 则必须将另外两项也进行选择，
     * 否则拦截提示“请将药品分类维护完整”；
     * 如果选择了器械分类中两项的其中一项，
     * 则必须将另外一项也进行选择，
     * 否则拦截提示“请将器械分类维护完整”)
     */
    checkCategory() {
      try {
        if (this.hasSelectCategoryByName('药品') && this.hasSelectCategoryByName('器械')) { // 药品器械并存
            let errorObj = {}
            let errorObjArr = []
            this.goodsTreeData.forEach(item=>{
              let name = item.text
              if (name !=='其他') {
                if (!errorObj[name]) {
                  errorObj[name] = this.hasSelectCategoryByName(name)
                  errorObjArr.push({
                    name,
                    select:this.hasSelectCategoryByName(name)
                  })
                }
              }
            })
            if (!errorObjArr.every(item=>item.select)) {
                let msg = this.errorPrompt(errorObj)
                throw new Error(`请将产品大类中的${msg}维护完整`)
            }
        } else {
          if (this.hasSelectCategoryByName('药品')) {
            let msg = this.getErrorMsg('药品')
            if (msg) {
              throw new Error(`请将产品大类中的${msg}维护完整`)
            }
          }
          if (this.hasSelectCategoryByName('器械')) {
            let msg = this.getErrorMsg('器械')
            if (msg) {
              throw new Error(`请将产品大类中的${msg}维护完整`)
            }
          }
        }
      } catch (error) {
        this.$message.warning(error.message);
        return false
      }
      return true
    },
    // 根据关键字获取大类的名称
    getCategoryNames(name) {
      let arr = []
      this.goodsTreeData.forEach(item=>{
        if (~item.text.indexOf(name)) {
          arr.push(item.text)
        }
      })
      return arr
    },
    // 根据关键字获取大类的子集
    getCategoryChild(name) {
      let arr = [];
      this.goodsTreeData.forEach((item) => {
        if (~item.text.indexOf(name)) {
          arr = arr.concat(item.childDictList);
        }
      });
      return arr;
    },
    // 根据关键字是否选择了某个产品大类
    hasSelectCategoryByName(name) {
      let flage = false;
      let arr = this.getCategoryChild(name);
      for (let index = 0; index < arr.length; index++) {
        const item = arr[index];
        if (~this.ruleForm.goodsClassGuids.indexOf(item.value)) {
          flage = true;
          break;
        }
      }
      return flage;
    },
    // 根据错误对象集合获取检验名称
    errorPrompt(errorObj) {
      let errorList = []
        for (const key in errorObj) {
          if (Object.hasOwnProperty.call(errorObj, key)) {
            const element = errorObj[key];
            if (!element) {
              errorList.push(`【${key}】`)
            }
          }
        }
      return errorList.join('、')
    },
    // 获取校验msg
    getErrorMsg(categoryName) {
      let errorObj = {}
      let errorObjArr = []
      this.getCategoryNames(categoryName).forEach(name=>{
        if (!errorObj[name]) {
          errorObj[name] = this.hasSelectCategoryByName(name)
          errorObjArr.push({
            name,
            select:this.hasSelectCategoryByName(name)
          })
        }
      })
      if (!errorObjArr.every(item=>item.select)) {
          let msg = this.errorPrompt(errorObj)
          return  msg
      }
    }
  },
};
</script>

<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 14px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}
.customer-information .col-itms .txt {
  width: 285px;
  text-align: left;
  margin-left: 15px;
}

.customer-information .col-itms.second {
  margin-left: 100px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.product-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.product-content-info {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 5px 10px;
}
.product-info {
  color: #a7a7a7;
}
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.flex-start {
  align-items: flex-start !important;
}

/* 产品表格样式 */
/deep/.product-list-table .el-table {
  font-size: 12px;
  color: #212121;
}
/deep/.product-list-table .el-table__body-wrapper tr,
.product-list-table .el-table__body td.el-table__cell {
  height: 40px;
}
/deep/.product-list-table .el-table__body-wrapper tr td {
  /* border-right: 1px solid #D9D9D9; */
}
/deep/.product-list-table .el-table .el-table__cell {
  padding: 0px;
}
/deep/.product-list-table .el-table th.el-table__cell {
  background-color: #f2f2f2;
  height: 32px;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
}
/deep/.product-list-table .el-table th.el-table__cell:last-child {
  border-right: none;
}
/deep/.product-list-table .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}
/* /deep/.product-list-table .el-table td.el-table__cell, .product-list-table .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #D9D9D9;
} */
/deep/.product-list .el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/deep/.product-list.el-dialog__body {
  padding: 10px 10px;
}
.el-col-10 {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
</style>
